import { useMutation } from "@apollo/client";
import { MUTATION_UPDATE_STOCKAGE } from "../graphql/mutations";

export const useUpdateStockage = () => {
  const [updateStockage] = useMutation(MUTATION_UPDATE_STOCKAGE);
  return {
    updateStockage,
  };
};
